import { render, staticRenderFns } from "./JWSFTP.vue?vue&type=template&id=21c2f3c0&"
import script from "./JWSFTP.vue?vue&type=script&lang=js&"
export * from "./JWSFTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports